export default "__VITE_ASSET__86M_oImh__"